import { useQuery } from "@tanstack/react-query";
import { usePublicClient } from "wagmi";
import { formatEther, PublicClient } from "viem";

const DEFAULT_GAS_LIMIT = 834661n;

const fetchEstimatedGasFee = async (client: PublicClient) => {
  const feeHistory = await client.getFeeHistory({
    blockCount: 4,
    rewardPercentiles: [95],
    blockTag: "latest",
  });

  if (!feeHistory || !feeHistory.baseFeePerGas) {
    return 0;
  }

  const baseFee = feeHistory.baseFeePerGas[feeHistory.baseFeePerGas.length - 1];

  const priorityFeeRewards = (feeHistory?.reward || []).map(
    (reward) => reward[0]
  );

  const averagePriorityFee =
    priorityFeeRewards.reduce((acc, fee) => acc + fee, 0n) /
    BigInt(priorityFeeRewards.length);

  const totalFeeInWei = (baseFee + averagePriorityFee) * DEFAULT_GAS_LIMIT;

  const totalFeeInEth = parseFloat(formatEther(totalFeeInWei)).toFixed(4);
  return totalFeeInEth;
};

export const useEstimatedGasFee = () => {
  const client = usePublicClient();

  const {
    data: estimatedGasFee,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["estimatedGasFee"],
    queryFn: async () => await fetchEstimatedGasFee(client as PublicClient),

    refetchInterval: 60000,
  });

  return { estimatedGasFee, isLoading, error };
};
